// 请求头，拦截器
import Axios from "axios";
import store from "../store/index";
// import router from "../router/index";
const request = Axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 10000, //请求超时时间
});
console.log(process.env);
// request拦截器
request.interceptors.request.use(
  (config) => {
    // 是否需要设置 token
    const token = store.state.user;
    const isToken = (config.headers || {}).isToken === false;
    if (token && !isToken) {
      // config.headers["Authorization"] = "Bearer " + token; // 让每个请求携带自定义token 请根据实际情况自行修改
      config.headers["token"] = token; //
    }
    // get请求映射params参数
    if (config.method === "get" && config.params) {
      let url = config.url + "?";
      for (const propName of Object.keys(config.params)) {
        const value = config.params[propName];
        var part = encodeURIComponent(propName) + "=";
        if (value && typeof value !== "undefined") {
          if (typeof value === "object") {
            for (const key of Object.keys(value)) {
              let params = propName + "[" + key + "]";
              var subPart = encodeURIComponent(params) + "=";
              url += subPart + encodeURIComponent(value[key]) + "&";
            }
          } else {
            url += part + encodeURIComponent(value) + "&";
          }
        }
      }
      url = url.slice(0, -1);
      config.params = {};
      config.url = url;
    }

    if (config.data && config.data.conditions) {
      for (let key in config.data.conditions) {
        if (
          config.data.conditions[key] === "" ||
          config.data.conditions[key] === null ||
          config.data.conditions[key] === undefined
        ) {
          delete config.data.conditions[key];
        }
      }
    }
    if (config.data) {
      for (let key in config.data) {
        if (
          config.data[key] === "" ||
          config.data[key] === null ||
          config.data[key] === undefined
        ) {
          delete config.data[key];
        }
      }
    }
    return config;
  },
  (error) => {
    console.log(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  function (response) {
    let code = response.data.code || response.code;
    let msg = response.data.msg || response.msg;
    if (msg == "请先登录" || msg == "登录已过期,请重新登录") {
      location.href = "#/"; // token过期，重定向到登录页
    } else if (code === 500) {
      console.log(msg);
      return Promise.reject(new Error(msg));
    } else {
      return response;
    }
  },
  (error) => {
    console.log(error);

    return Promise.reject(error);
  }
);

export default request;
